export default __webpack_public_path__ + "static/media/GR3 1A-2E-1EC.c3f47976.jpg";